const COMMUNITY_ARTWORK_VIEW_SOURCE = Object.freeze({
  type: 'community',
  label: '',
});

export function createCommunityArtworkNavigationState(extraState = {}) {
  return {
    from: true,
    artworkViewSource: { ...COMMUNITY_ARTWORK_VIEW_SOURCE },
    ...extraState,
  };
}
